'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "TeachingPopoverHeader", {
    enumerable: true,
    get: function() {
        return TeachingPopoverHeader;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _useTeachingPopoverHeader = require("./useTeachingPopoverHeader");
const _renderTeachingPopoverHeader = require("./renderTeachingPopoverHeader");
const _useTeachingPopoverHeaderStylesstyles = require("./useTeachingPopoverHeaderStyles.styles");
const _reactsharedcontexts = require("@fluentui/react-shared-contexts");
const TeachingPopoverHeader = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useTeachingPopoverHeader.useTeachingPopoverHeader_unstable)(props, ref);
    (0, _useTeachingPopoverHeaderStylesstyles.useTeachingPopoverHeaderStyles_unstable)(state);
    (0, _reactsharedcontexts.useCustomStyleHook_unstable)('useTeachingPopoverHeaderStyles_unstable')(state);
    return (0, _renderTeachingPopoverHeader.renderTeachingPopoverHeader_unstable)(state);
});
TeachingPopoverHeader.displayName = 'TeachingPopoverHeader';
